<template>
  <section>
    <!-- 面包屑 -->
    <breadcrumbs></breadcrumbs>
    <div class="filterBox">
      <el-form :inline="true" ref="filterForm" :model="filterForm" label-width="100px" class="bg-white pd-10">
        <el-form-item label="消息内容">
          <el-input v-model="filterForm.noticeTitle" placeholder="请输入消息内容" clearable style="width: 200px"></el-input>  
        </el-form-item>



        <el-form-item label="报警时间">
          <el-date-picker v-model="filterForm.startTime" type="datetime" placeholder="选择开始报警时间"
            format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" style="width: 200px"
            :picker-options="startDatePickerOptions">
          </el-date-picker>
          至
          <el-date-picker v-model="filterForm.endTime" type="datetime" placeholder="选择结束报警时间"
            format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" :picker-options="endDatePickerOptions"
            style="width: 200px">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getSearchData">查询</el-button>
          <el-button @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- <btns @exec="exec"></btns> -->
    <div class="data-container mgt-20 scroll-table">
      <el-collapse v-model="activeNames">
        <div v-for="item in tableData" :key="item.id" :name="item.messageRecId" @click="listgo(item)">
          <el-collapse-item>
            <template slot="title">
              <i v-if="item.state == 1" class="mgr-20">
                <el-badge is-dot class="item"> </el-badge>
              </i>
              <div class="boxtop" v-if="item.isRead == false"></div>
              <div class="boxtopX" v-if="item.isRead == true"></div>
              <div class="boxmain">
                <div>{{ item.noticeTitle }}</div>
                <div class="box ">{{ item.sendTime }}</div>
              </div>
            </template>
            <!-- <div class="mgl-50" v-html="item.noticeText"></div> -->
            <div class="mgl-50">
              <!-- 使用flex布局让内容和链接在同一行 -->
              <div class="message-content-wrapper" v-if="item.noticeType == 8">
                <!-- 原始消息内容 - 使用span避免换行 -->
                <span class="message-text" v-html="item.noticeText"></span>

                <!-- 跳转链接 - 在同一行显示 -->
                <span class="purchase-link" @click="goToPurchase(item)" @click.stop>
                  点击前往续费>
                </span>
              </div>
              <div class="message-content-wrapper" v-else-if="item.noticeType == 9">
                <!-- 原始消息内容 - 使用span避免换行 -->
                <span class="message-text" v-html="item.noticeText"></span>

                <!-- 跳转链接 - 在同一行显示 -->
                <span class="purchase-link" @click="goToPurchase(item)" @click.stop>
                  点击前往续费>
                </span>
              </div>

              <!-- noticeType不为1时只显示原始内容 -->
              <div v-else v-html="item.noticeText"></div>
            </div>
          </el-collapse-item>
        </div>
      </el-collapse>
    </div>
    <div class="pages">
      <!-- 分页器 -->
      <el-pagination class="mgt-20" background @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="page" :page-sizes="[5, 20, 30, 40, 50]" :page-size="pageSize" layout=" prev, pager, next"
        :total="total">
      </el-pagination>
    </div>
  </section>
</template>

<script>
import btns from "@/components/btns.vue";
import Editor from "@/components/edit";
import breadcrumbs from "@/components/breadcrumbs.vue";
import EventBus from "../../utils/EventBus";
export default {
  components: {
    btns,
    Editor,
    breadcrumbs,
  },
  data() {
    var FengValidate = (rule, value, callback) => {
      // console.log(this.addfile);
      if (this.addfile == "") {
        callback(new Error("请选择封面图片"));
      }
      // if (value == null || value == '') {
      //   this.activeNames = ['2'];
      // }
    };
    return {
      activeNames: ["1"],
      EditAddfile: "",
      createAddfile: "",
      hasFile: false,
      isShowGoodsListEdit: false,
      isShowProductListEdit: false,
      isShowFengEdit: false,
      isShowEditedit: false,
      EditForm: {},
      dialogEditFormVisible: false,
      isShowGoodsList: false,
      isShowProductList: false,
      isShowFeng: false,
      ProductList: [],
      GoodsList: [],
      isShow: false,
      Adaddfile: "",
      searchForm: { name: "" },
      tableData: [],
      page: 1,
      pageSize: 10,
      total: 50,
      dialogCreateFormVisible: false,
      createForm: {},
      formLabelWidth: "120px",
      addfile: "",
      importFileUrl: this.GLOBAL.imgBaseUrl,
      isShowEdit: false,
      filterForm: {
        noticeTitle: "",
        startTime: "",
        endTime: "",
      },
      startDatePickerOptions: {
        disabledDate: (time) => {
          if (this.filterForm.endTime) {
            // 如果有结束时间，开始时间不能大于结束时间
            return time.getTime() > new Date(this.filterForm.endTime).getTime();
          }
          return false;
        }
      },

      // 结束时间选择器的限制
      endDatePickerOptions: {
        disabledDate: (time) => {
          if (this.filterForm.startTime) {
            // 如果有开始时间，结束时间不能小于开始时间
            return time.getTime() < new Date(this.filterForm.startTime).getTime();
          }
          return false;
        }
      }
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getSearchData() {
      // 构建查询参数
      const queryParams = {
        noticeTitle: this.filterForm.noticeTitle,
        startTime: this.filterForm.startTime,
        endTime: this.filterForm.endTime,
      };

      // 重置分页参数
      this.page = 1;

      this.getList();
    },
    handleReset() {
      // 重置查询表单
      this.filterForm = {
        noticeTitle: "",
        startTime: "",
        endTime: "",
      };

      // 重置分页参数
      this.page = 1;

      // 调用获取列表方法
      this.getList();
    },
    goToPurchase(item) {
      // 阻止事件冒泡，避免触发父级的点击事件
      event.stopPropagation();

      // 获取商品ID或跳转路径，根据您的实际数据结构调整
      const productId = item.productId || item.goodsId;

      if (productId) {
        // 跳转到商品详情页
        this.$router.push(`/product/detail/${productId}`);
      } else {
        // 如果没有商品ID，可以跳转到商品列表页
        this.$router.push('/valueAddedService/valueAddedService');
      }

      console.log('前往购买', item);
    },
    getList() {
      this.$api.system
        .news2({
          ...this.filterForm,
          pageNum: this.page,
          pageSize: this.pageSize,
        })
        .then((d) => {
          if (d.code == 200) {
            this.tableData = d.data.rows;
            this.total = d.data.total;
          }
        });
    },
    listgo(i) {
      if (i.isRead == false) {
        this.$api.system
          .gonews({
            id: i.id,
          })
          .then((res) => {
            if (res.code === 200) {
              this.getList();
              this.getNone();
            }
          });
      }
    },
    getNone() {
      this.$api.system
        .msgNum({ isRead: false })
        .then((d) => {
          if (d.code === 200) {
            EventBus.$emit("none", d.data);
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    // 当前页面,当前页面改变时触发事件
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
  },
};
</script>

<style lang="scss" scoped>
.dialog-footer {
  margin-top: 50px;
}

.img-feng {
  width: 120px;
  height: 120px;
}

.goods {
  width: 500px;
}

.icon {
  display: flex;
  justify-content: space-between;

  i {
    font-size: 25px;
  }
}

.baoqi {
  display: flex;
  justify-content: flex-end;
}

.juyou {}

.tiaozhegn {
  display: flex;
  justify-content: space-between;
}

.boxtop {
  width: 10px;
  height: 10px;
  background-color: var(--danger); /* 未读红点 */
  border-radius: 50%;
  margin-right: 20px;
  margin-left: 20px;
}

.boxtopX {
  // border: 0.3rem solid var(--input-border);
  // border-radius: 50%;

  width: 10px;
  height: 10px;
  background-color: var(--text-muted); /* 已读灰点 */
  border-radius: 50%;
  margin-right: 20px;
  margin-left: 20px;
}

.boxmain {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

/deep/ .el-icon-arrow-right {
  margin-left: 20px;
}

/deep/ .pages .el-icon-arrow-right {
  margin-left: 0px;
}

.message-content-wrapper {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px 8px;
  /* 行间距4px，列间距8px */
  line-height: 1.6;
}

.message-text {
  display: inline;
  color: var(--text-sub);
  font-size: 14px;
}

.message-text /deep/ p {
  display: inline;
  margin: 0;
}

.message-text /deep/ a {
  color: var(--accent);
  text-decoration: none;
}

.message-text /deep/ a:hover {
  text-decoration: underline;
}

.purchase-link {
  display: inline-flex;
  align-items: center;
  color: var(--accent);
  font-size: 14px;
  cursor: pointer;
  text-decoration: underline;
  white-space: nowrap;
  /* 防止换行 */
  transition: color 0.3s;
}

.purchase-link:hover {
  color: #66b1ff;
}

/* 可选：如果消息内容本身有换行，确保链接紧跟在后面 */
.message-text /deep/ br {
  display: none;
  /* 隐藏可能的换行符 */
}

.message-text /deep/ div {
  display: inline;
  /* 将块级元素转为行内 */
}
</style>
